import { MoreHoriz } from "@mui/icons-material";
import {
	Box,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import gradientImage from "../../../assets/images/other/gradient.png";
import rockAndRoll from "../../../assets/images/rock-and-roll/rock-and-roll.png";
import drawerIconDark from "../../../assets/images/shoutOuts-icons/Shout Out Dark.svg";
import drawerIconLight from "../../../assets/images/shoutOuts-icons/Shout Out Light.svg";
import { node_server } from "../../../constants";
import { useTheme } from "../../../context/themeContext";
import { sendShoutOutReceivedEmail } from "../../../helpers/emails";
import useDiscover from "../../../hooks/useDiscover";
import UseLocalStorageState from "../../../hooks/useLocalStorageState";
import useManageProjects from "../../../hooks/useManageProjects";
import { setData as setFeedData } from "../../../store/slices/profile/discoverSlice";
import supabase from "../../../supabase/client";
import FlagConfirmation from "./Flag-confirmation";
import styles from "./style.module.css";
import ProfileTabs from "./tabs";

function Header({ data }) {
	const { theme, darkMode } = useTheme();
	const [gaveShout, setGaveShoutOut] = useState(false);
	const params = useParams();
	const user = useSelector((state) => state.user.value);
	const creator = useSelector((state) => state.publicUser.value);
	const [flags, setFlags] = useState([]);
	const { isDrawerOpen } = useSelector((state) => state.manageProjects);
	const { toggleDrawer } = useManageProjects();
	const [hideIndcator, setHideIndcator] = UseLocalStorageState(
		"hideIndcator",
		false,
	);
	const [isFlagModalOpen, setIsFlagModalOpen] = useState(false);
	const dispatch = useDispatch();
	const { data: feedData } = useSelector((state) => state.discover);
	useDiscover(true);

	const handleShutClick = () => {
		data.setValue(3);
		setHideIndcator(true);
	};

	const handleShoutOutClick = async () => {
		if (gaveShout) {
			cancelShoutOut();
			return;
		}

		const response = await axios.post(
			`${node_server}/api/shoutouts/give`,
			{
				receiverId: creator.id,
			},
			{
				withCredentials: true,
			},
		);
		if (response.status === 200) {
			setGaveShoutOut(true);
			await sendShoutOutReceivedEmail(creator.id);

			if (feedData.length !== 0) {
				const matchedItem = feedData.filter(
					(item) => item.matched_user_id === creator.id,
				);

				dispatch(
					setFeedData(
						feedData.map((item) =>
							item === matchedItem[0]
								? { ...item, shout_outed: true }
								: item,
						),
					),
				);
			}

			const response = await axios.post(
				`${node_server}/api/user-feed/update`,
				{
					matched_user_id: creator.id,
					shout_outed: true,
				},
				{
					withCredentials: true,
				},
			);
			if (response.status !== 200) {
				console.error("Error updating feed", response.data);
			}
		} else {
			console.log(response.data);
		}
	};

	const cancelShoutOut = async () => {
		if (gaveShout) {
			const response = await axios.post(
				`${node_server}/api/shoutouts/cancel`,
				{
					receiverId: creator.id,
				},
				{
					withCredentials: true,
				},
			);
			if (response.status === 200) {
				setGaveShoutOut(false);
			}
		}
	};

	const handleFlagClick = async () => {
		if (flags.length > 0) {
			const response = await axios.delete(
				`${node_server}/api/user/flags`,
				{
					withCredentials: true,
					params: { userId: creator.id },
				},
			);
			if (response.status === 200) {
				setFlags([]);
			}
		} else {
			const response = await axios.post(
				`${node_server}/api/user/flag`,
				{
					userId: creator.id,
				},
				{ withCredentials: true },
			);
			if (response.status === 200) {
				setFlags([{ reporter_id: user.id, reported_id: creator.id }]);
			}
		}
	};

	useEffect(() => {
		const fetchShoutOuts = async () => {
			const response = await axios.post(
				`${node_server}/api/shoutouts/given/receiver`,
				{
					receiverId: params?.id,
				},
				{
					withCredentials: true,
				},
			);

			if (response.status === 200 && response.data.length > 0) {
				setGaveShoutOut(true);
			}
		};

		const fetchFlags = async () => {
			const response = await axios.get(
				`${node_server}/api/user/flags`,
				{
					withCredentials: true,
					params: {
						userId: params?.id,
					},
				},
			);
			if (response.status === 200) {
				setFlags(response.data);
			}
		};

		if (user?.id) {
			fetchShoutOuts();
			fetchFlags();
		}
	}, [user, params]);

	const DrawerList = (
		<Box role="presentation" onClick={toggleDrawer(false)}>
			<Box
				sx={{
					display: "flex",
					alignSelf: "stretch",
					justifyContent: "center",
					padding: "8px 16px 24px",
				}}
			>
				<Box
					sx={{
						width: "54px",
						height: "4px",
						borderRadius: "32px",
						background: theme.palette.darkgrey.darkgrey500,
					}}
				></Box>
			</Box>
			<List sx={{ p: "8px 0px 24px" }}>
				<ListItem sx={{ p: "8px 0px" }}>
					<ListItemButton
						onClick={handleShutClick}
						sx={{ paddingLeft: "24px" }}
					>
						<ListItemIcon sx={{ minWidth: "50px" }}>
							{darkMode ? (
								<img
									src={drawerIconDark}
									height={"24px"}
									alt={"rock"}
								/>
							) : (
								<img
									src={drawerIconLight}
									height={"24px"}
									alt={"rock"}
								/>
							)}
						</ListItemIcon>
						<ListItemText
							sx={{
								color: darkMode
									? theme.palette.darkgrey.darkgrey400
									: theme.palette.darkgrey.darkgrey500,
							}}
							primary={"Shout Outs"}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem sx={{ p: "8px 0px" }}>
					<ListItemButton
						onClick={handleShoutOutClick}
						sx={{ paddingLeft: "24px" }}
					>
						<ListItemIcon sx={{ minWidth: "50px" }}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M11.3055 3.20742C11.533 2.81156 11.6467 2.61363 11.7954 2.5473C11.925 2.48944 12.0732 2.48944 12.2028 2.5473C12.3515 2.61363 12.4652 2.81156 12.6927 3.20742L14.6479 6.60974C14.7321 6.75628 14.7742 6.82955 14.8332 6.8828C14.8855 6.92991 14.9471 6.96547 15.014 6.98715C15.0896 7.01166 15.1741 7.01149 15.3431 7.01114L19.2672 7.0032C19.7238 7.00228 19.9521 7.00182 20.0838 7.0974C20.1988 7.18077 20.2729 7.30906 20.2876 7.45029C20.3045 7.6122 20.1899 7.80967 19.9608 8.2046L17.9919 11.599C17.9071 11.7452 17.8647 11.8183 17.8481 11.896C17.8335 11.9648 17.8335 12.0359 17.8481 12.1047C17.8647 12.1825 17.9071 12.2556 17.9919 12.4018L19.9608 15.7962C20.1899 16.1911 20.3045 16.3886 20.2876 16.5505C20.2729 16.6917 20.1988 16.82 20.0838 16.9034C19.9521 16.999 19.7238 16.9985 19.2672 16.9976L15.3431 16.9896C15.1741 16.9893 15.0896 16.9891 15.014 17.0136C14.9471 17.0353 14.8855 17.0709 14.8332 17.118C14.7742 17.1712 14.7321 17.2445 14.6479 17.391L12.6927 20.7934C12.4652 21.1892 12.3515 21.3871 12.2028 21.4535C12.0732 21.5113 11.925 21.5113 11.7954 21.4535C11.6467 21.3871 11.533 21.1892 11.3055 20.7934L9.35031 17.391C9.2661 17.2445 9.22399 17.1712 9.16495 17.118C9.11272 17.0709 9.05113 17.0353 8.98421 17.0136C8.90858 16.9891 8.82407 16.9893 8.65506 16.9896L4.73098 16.9976C4.27442 16.9985 4.04614 16.999 3.91435 16.9034C3.79942 16.82 3.72534 16.6917 3.71062 16.5505C3.69373 16.3886 3.80827 16.1911 4.03735 15.7962L6.00627 12.4018C6.09107 12.2556 6.13347 12.1825 6.15006 12.1047C6.16474 12.0359 6.16474 11.9648 6.15006 11.896C6.13347 11.8183 6.09107 11.7452 6.00627 11.599L4.03735 8.2046C3.80827 7.80967 3.69373 7.6122 3.71062 7.45029C3.72534 7.30906 3.79942 7.18077 3.91435 7.0974C4.04614 7.00182 4.27442 7.00228 4.73098 7.0032L8.65506 7.01114C8.82407 7.01149 8.90858 7.01166 8.98421 6.98715C9.05113 6.96547 9.11272 6.92991 9.16495 6.8828C9.22399 6.82955 9.2661 6.75628 9.35031 6.60974L11.3055 3.20742Z"
									stroke={
										gaveShout
											? theme.palette.primary.purpel300
											: darkMode
											? theme.palette.darkgrey.darkgrey400
											: "#5C595C"
									}
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</ListItemIcon>
						<ListItemText
							sx={{
								color: gaveShout
									? theme.palette.primary.purpel300
									: darkMode
									? theme.palette.darkgrey.darkgrey400
									: theme.palette.darkgrey.darkgrey500,
							}}
							primary={gaveShout ? "Favorite Added" : "Favorite"}
						/>
					</ListItemButton>
				</ListItem>
				<ListItem sx={{ p: "8px 0px" }}>
					<ListItemButton
						onClick={() => setIsFlagModalOpen(true)}
						sx={{ paddingLeft: "24px" }}
					>
						<ListItemIcon sx={{ minWidth: "50px" }}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3L4 22"
									stroke={
										flags.length > 0
											? theme.palette.danger.red400
											: darkMode
											? theme.palette.darkgrey.darkgrey400
											: "#5C595C"
									}
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</ListItemIcon>
						<ListItemText
							sx={{
								color:
									flags.length > 0
										? theme.palette.danger.red400
										: darkMode
										? theme.palette.darkgrey.darkgrey400
										: theme.palette.darkgrey.darkgrey500,
							}}
							primary={flags.length > 0 ? "Flagged" : "Flag User"}
						/>
					</ListItemButton>
				</ListItem>
			</List>
		</Box>
	);

	return (
		<React.Fragment>
			{flags.length <= 0 && (
				<FlagConfirmation
					isOpen={isFlagModalOpen}
					setIsOpen={setIsFlagModalOpen}
					handleFlagClick={handleFlagClick}
				/>
			)}
			<Box
				className={styles.myCardDetails}
				style={{ backgroundImage: `url(${gradientImage})` }}
			>
				<Box className={styles.userDetails}>
					<Box className={styles.details}>
						<Box className={styles.image__parent}>
							<Box
								className={styles.image}
								sx={{
									backgroundImage: `url(${creator?.profile_image})`,
									backgroundSize: "cover",
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center center",
								}}
							></Box>
						</Box>

						<Box className={styles.name}>
							<Typography
								variant="body1"
								component="h6"
								sx={{
									color: "#FFF",
									lineHeight: "1rem",
									fontSize: {
										xs: "16px",
										sm: "20px",
									},
								}}
							>
								{creator?.real_name}
							</Typography>
							<Typography
								variant="body1"
								sx={{
									color: theme.palette.tertiary.golden500,
								}}
							>
								{creator?.nick_name}
							</Typography>
						</Box>
					</Box>
					<Box
						className={styles.shouts}
						sx={{
							bgcolor: gaveShout
								? theme.palette.warning.main
								: theme.palette.darkgrey.darkgrey400,
						}}
						onClick={handleShoutOutClick}
					>
						<img
							src={rockAndRoll}
							width="100%"
							height="100%"
							alt="rock-and-roll"
						/>
					</Box>
				</Box>
				<Box className={styles.tabs}>
					<ProfileTabs
						isIndecatorHide={hideIndcator}
						setHideIndcator={setHideIndcator}
						data={data}
					/>
					<IconButton onClick={toggleDrawer(true)}>
						<MoreHoriz sx={{ color: "#FFF" }} />
					</IconButton>
					<Drawer
						anchor="bottom"
						open={isDrawerOpen}
						onClose={toggleDrawer(false)}
						sx={{
							"& .MuiPaper-root": {
								maxWidth: {
									xs: "100%",
								},
								md: {
									left: "50% !important",
									maxWidth: "400px !important",
									transform: "translateX(-50%) !important",
								},
							},
						}}
					>
						{DrawerList}
					</Drawer>
				</Box>
			</Box>
		</React.Fragment>
	);
}

export default Header;
